import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withCtx as _withCtx, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, normalizeClass as _normalizeClass, vShow as _vShow, withDirectives as _withDirectives, Transition as _Transition, createBlock as _createBlock, vModelText as _vModelText, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '../../static/images/prev.png'
import _imports_1 from '../../static/images/next.png'


const _withScopeId = n => (_pushScopeId("data-v-2260106f"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "ins-banner" }
const _hoisted_2 = ["src"]
const _hoisted_3 = { class: "txt padding" }
const _hoisted_4 = ["innerHTML"]
const _hoisted_5 = { class: "bread padding" }
const _hoisted_6 = { class: "bd" }
const _hoisted_7 = /*#__PURE__*/_createTextVNode("首页")
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "渠道合作", -1))
const _hoisted_9 = { class: "clla-you padding" }
const _hoisted_10 = { class: "clla-title" }
const _hoisted_11 = { class: "con" }
const _hoisted_12 = { class: "flex" }
const _hoisted_13 = { class: "tabs" }
const _hoisted_14 = ["onClick"]
const _hoisted_15 = { class: "icon" }
const _hoisted_16 = ["src"]
const _hoisted_17 = { class: "right" }
const _hoisted_18 = { class: "item" }
const _hoisted_19 = ["src"]
const _hoisted_20 = { class: "txt" }
const _hoisted_21 = { class: "t" }
const _hoisted_22 = { class: "desc" }
const _hoisted_23 = { class: "clla-he" }
const _hoisted_24 = { class: "clla-title padding" }
const _hoisted_25 = { class: "con" }
const _hoisted_26 = ["src"]
const _hoisted_27 = { class: "prev-next" }
const _hoisted_28 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_0,
  alt: "",
  class: "gd"
}, null, -1))
const _hoisted_29 = [
  _hoisted_28
]
const _hoisted_30 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_1,
  alt: "",
  class: "gd"
}, null, -1))
const _hoisted_31 = [
  _hoisted_30
]
const _hoisted_32 = { class: "clla-liu padding" }
const _hoisted_33 = { class: "clla-title" }
const _hoisted_34 = { class: "con" }
const _hoisted_35 = /*#__PURE__*/_createTextVNode("联系我们：")
const _hoisted_36 = { class: "items" }
const _hoisted_37 = ["src"]
const _hoisted_38 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "meng" }, null, -1))
const _hoisted_39 = { class: "txt" }
const _hoisted_40 = ["innerHTML"]
const _hoisted_41 = { class: "num" }
const _hoisted_42 = { class: "clla-ban" }
const _hoisted_43 = { class: "clla-title" }
const _hoisted_44 = { class: "con" }
const _hoisted_45 = { class: "fx" }
const _hoisted_46 = { class: "w" }
const _hoisted_47 = { class: "item" }
const _hoisted_48 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "t d" }, "您的姓名：", -1))
const _hoisted_49 = { class: "w" }
const _hoisted_50 = { class: "item" }
const _hoisted_51 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "t d" }, "您的电话：", -1))
const _hoisted_52 = { class: "fx" }
const _hoisted_53 = { class: "w" }
const _hoisted_54 = { class: "item" }
const _hoisted_55 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "t d" }, "公司名称：", -1))
const _hoisted_56 = { class: "w" }
const _hoisted_57 = { class: "item" }
const _hoisted_58 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "t d" }, "您的微信：", -1))
const _hoisted_59 = { class: "item" }
const _hoisted_60 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "t" }, "您的留言：", -1))
const _hoisted_61 = { class: "tp" }
const _hoisted_62 = { class: "btns" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Header = _resolveComponent("Header")!
  const _component_router_link = _resolveComponent("router-link")!
  const _component_swiper_slide = _resolveComponent("swiper-slide")!
  const _component_swiper = _resolveComponent("swiper")!
  const _component_Footer = _resolveComponent("Footer")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_Header),
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("img", {
        src: _ctx.banner.banner,
        alt: "",
        class: "img"
      }, null, 8, _hoisted_2),
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("h5", null, _toDisplayString(_ctx.banner.name), 1),
        _createElementVNode("h3", {
          innerHTML: _ctx.banner.text
        }, null, 8, _hoisted_4)
      ]),
      _createElementVNode("div", _hoisted_5, [
        _createElementVNode("div", _hoisted_6, [
          _createVNode(_component_router_link, { to: "/" }, {
            default: _withCtx(() => [
              _hoisted_7
            ]),
            _: 1
          }),
          _hoisted_8
        ])
      ])
    ]),
    _createElementVNode("div", _hoisted_9, [
      _createElementVNode("div", _hoisted_10, [
        _createElementVNode("h4", null, _toDisplayString(_ctx.wmdys.name), 1),
        _createElementVNode("div", _hoisted_11, _toDisplayString(_ctx.wmdys.f_title), 1)
      ]),
      _createElementVNode("div", _hoisted_12, [
        _createElementVNode("ul", _hoisted_13, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.wmdys.list, (item, index) => {
            return (_openBlock(), _createElementBlock("li", {
              key: item.id,
              class: _normalizeClass(_ctx.youIndex == index ? 'active' : ''),
              onClick: ($event: any) => (_ctx.tabYou(index))
            }, [
              _createElementVNode("div", _hoisted_15, [
                _createElementVNode("img", {
                  src: item.icon_image,
                  alt: ""
                }, null, 8, _hoisted_16)
              ]),
              _createElementVNode("p", null, _toDisplayString(item.title), 1)
            ], 10, _hoisted_14))
          }), 128))
        ]),
        _createElementVNode("div", _hoisted_17, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.wmdys.list, (item, index) => {
            return (_openBlock(), _createElementBlock("div", {
              class: "list",
              key: item.id
            }, [
              _createVNode(_Transition, { name: "fade" }, {
                default: _withCtx(() => [
                  _withDirectives(_createElementVNode("div", _hoisted_18, [
                    _createElementVNode("img", {
                      src: item.image,
                      alt: "",
                      class: "img"
                    }, null, 8, _hoisted_19),
                    _createElementVNode("div", _hoisted_20, [
                      _createElementVNode("div", _hoisted_21, _toDisplayString(item.title), 1),
                      _createElementVNode("div", _hoisted_22, _toDisplayString(item.text), 1)
                    ])
                  ], 512), [
                    [_vShow, _ctx.youIndex == index]
                  ])
                ]),
                _: 2
              }, 1024)
            ]))
          }), 128))
        ])
      ])
    ]),
    _createElementVNode("div", _hoisted_23, [
      _createElementVNode("div", _hoisted_24, [
        _createElementVNode("h4", null, _toDisplayString(_ctx.hzzc.name), 1),
        _createElementVNode("div", _hoisted_25, _toDisplayString(_ctx.hzzc.f_title), 1)
      ]),
      _createVNode(_component_swiper, {
        class: "swp-clla",
        loop: _ctx.swiperClla.loop,
        loopedSlides: _ctx.swiperClla.loopedSlides,
        slidesPerView: _ctx.swiperClla.slidesPerView,
        centeredSlides: _ctx.swiperClla.centeredSlides,
        centerInsufficientSlides: _ctx.swiperClla.centerInsufficientSlides,
        onSwiper: _ctx.setControlledSwiperClla
      }, {
        default: _withCtx(() => [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.hzzc.list, (item) => {
            return (_openBlock(), _createBlock(_component_swiper_slide, {
              key: item.id
            }, {
              default: _withCtx(() => [
                _createElementVNode("img", {
                  src: item.image,
                  alt: "",
                  class: "icon"
                }, null, 8, _hoisted_26),
                _createElementVNode("h6", null, _toDisplayString(item.title), 1),
                _createElementVNode("p", null, _toDisplayString(item.text), 1)
              ]),
              _: 2
            }, 1024))
          }), 128))
        ]),
        _: 1
      }, 8, ["loop", "loopedSlides", "slidesPerView", "centeredSlides", "centerInsufficientSlides", "onSwiper"]),
      _createElementVNode("div", _hoisted_27, [
        _createElementVNode("div", {
          class: "prev",
          onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.cllaPrev && _ctx.cllaPrev(...args)))
        }, _hoisted_29),
        _createElementVNode("div", {
          class: "next",
          onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.cllaNext && _ctx.cllaNext(...args)))
        }, _hoisted_31)
      ])
    ]),
    _createElementVNode("div", _hoisted_32, [
      _createElementVNode("div", _hoisted_33, [
        _createElementVNode("h4", null, _toDisplayString(_ctx.hzlc.name), 1),
        _createElementVNode("div", _hoisted_34, [
          _hoisted_35,
          _createElementVNode("span", null, _toDisplayString(_ctx.hzlc.f_title), 1)
        ])
      ]),
      _createElementVNode("div", _hoisted_36, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.hzlc.list, (item, index) => {
          return (_openBlock(), _createElementBlock("div", {
            class: "item",
            key: item.id
          }, [
            _createElementVNode("img", {
              src: item.image,
              alt: "",
              class: "img gd"
            }, null, 8, _hoisted_37),
            _hoisted_38,
            _createElementVNode("div", _hoisted_39, [
              _createElementVNode("p", {
                innerHTML: item.title
              }, null, 8, _hoisted_40),
              _createElementVNode("div", _hoisted_41, "0" + _toDisplayString(index + 1), 1)
            ])
          ]))
        }), 128))
      ])
    ]),
    _createElementVNode("div", _hoisted_42, [
      _createElementVNode("div", _hoisted_43, [
        _createElementVNode("h4", null, _toDisplayString(_ctx.ljcwhb.name), 1),
        _createElementVNode("div", _hoisted_44, _toDisplayString(_ctx.ljcwhb.f_title), 1)
      ]),
      _createElementVNode("div", _hoisted_45, [
        _createElementVNode("div", _hoisted_46, [
          _createElementVNode("div", _hoisted_47, [
            _hoisted_48,
            _withDirectives(_createElementVNode("input", {
              type: "text",
              "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.name) = $event))
            }, null, 512), [
              [_vModelText, _ctx.name]
            ])
          ])
        ]),
        _createElementVNode("div", _hoisted_49, [
          _createElementVNode("div", _hoisted_50, [
            _hoisted_51,
            _withDirectives(_createElementVNode("input", {
              type: "text",
              "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.mobile) = $event))
            }, null, 512), [
              [_vModelText, _ctx.mobile]
            ])
          ])
        ])
      ]),
      _createElementVNode("div", _hoisted_52, [
        _createElementVNode("div", _hoisted_53, [
          _createElementVNode("div", _hoisted_54, [
            _hoisted_55,
            _withDirectives(_createElementVNode("input", {
              type: "text",
              "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.company) = $event))
            }, null, 512), [
              [_vModelText, _ctx.company]
            ])
          ])
        ]),
        _createElementVNode("div", _hoisted_56, [
          _createElementVNode("div", _hoisted_57, [
            _hoisted_58,
            _withDirectives(_createElementVNode("input", {
              type: "text",
              "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.weixin) = $event))
            }, null, 512), [
              [_vModelText, _ctx.weixin]
            ])
          ])
        ])
      ]),
      _createElementVNode("div", _hoisted_59, [
        _hoisted_60,
        _withDirectives(_createElementVNode("textarea", {
          "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.content) = $event))
        }, null, 512), [
          [_vModelText, _ctx.content]
        ])
      ]),
      _createElementVNode("div", _hoisted_61, _toDisplayString(_ctx.ljcwhb.text), 1),
      _createElementVNode("div", _hoisted_62, [
        _createElementVNode("div", {
          class: "btn s",
          onClick: _cache[7] || (_cache[7] = 
//@ts-ignore
(...args) => (_ctx.Submit && _ctx.Submit(...args)))
        }, "立即提交"),
        _createElementVNode("div", {
          class: "btn r",
          onClick: _cache[8] || (_cache[8] = 
//@ts-ignore
(...args) => (_ctx.Reset && _ctx.Reset(...args)))
        }, "重置")
      ])
    ]),
    _createVNode(_component_Footer)
  ], 64))
}